import React from 'react';
import classNames from 'classnames';

import styles from './sidebarWidgetStyles';

const SidebarWidget = props => (
  <div className={classNames(styles.sidebarWidget, { [styles.noPadding]: props.noPadding })}>
    {props.children}
  </div>
);

export default SidebarWidget;
